import React from 'react';
import './TextVerificationInput.css';

type Props = {
  className?: string;
  value: string;
  placeholder: string;
  name: string;
  errorMessage: string;
  onChange: (e: any) => void;
};

const TextVerificationInput: React.FC<Props> = ({
  className,
  value,
  name,
  placeholder,
  errorMessage,
  onChange,
}: Props) => {
  return (
    <div className={`TextVerificationInput ${className ? className : ''}`}>
      <div
        className={`inner-container ${errorMessage !== '' ? 'has-error' : ''}`}
      >
        <input
          type='text'
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
        <span className='error-message'>{errorMessage}</span>
      </div>
    </div>
  );
};

export default TextVerificationInput;
